import { useNavigate } from 'react-router-dom'
import { useTranslation } from '../../i18n'
import { useTheme } from '../../hooks/useTheme'
import { useAuth } from '../../contexts/AuthContext'
import { useUserPreferences } from '../../contexts/UserPreferencesContext'
import { getDefaultShortcuts, resolveShortcuts } from '../../config/quickAccessItems'

export default function QuickAccessBar() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const theme = useTheme()
  const { user } = useAuth()
  const { preferences } = useUserPreferences()

  const keys =
    preferences?.pinnedShortcuts?.length
      ? preferences.pinnedShortcuts
      : getDefaultShortcuts(user?.hasTrainees ?? false, user?.hasCoaches ?? false)

  const items = resolveShortcuts(keys)

  if (items.length === 0) return null

  return (
    <div className="mt-5" data-tour="tour-quick-access">
      <div className="flex items-center justify-between mb-3">
        <span className="text-base font-bold" style={{ color: theme.text.primary }}>
          {t.quickAccess.title}
        </span>
        <button
          type="button"
          onClick={() => navigate('/quick-access')}
          className="text-sm font-semibold"
          style={{ color: theme.buttonColor || theme.accent.text }}
        >
          {t.quickAccess.editHint}
        </button>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {items.map(item => (
          <button
            key={item.key}
            type="button"
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center gap-2 py-3 rounded-2xl active:scale-95 transition-transform"
            style={{ backgroundColor: theme.cardBg, border: `1px solid ${theme.cardBorder}` }}
          >
            <span
              className="w-11 h-11 rounded-xl flex items-center justify-center text-xl"
              style={{ backgroundColor: `${theme.buttonColor}15` }}
            >
              {item.emoji}
            </span>
            <span className="text-xs font-medium text-center leading-tight px-1" style={{ color: theme.text.primary }}>
              {t.quickAccess.items[item.labelKey]}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
